import { useEffect } from 'react';

export const DEFAULT_ORG_NAME = 'Nimble Energy';

export default function usePageTitle(title = DEFAULT_ORG_NAME) {
  useEffect(() => {
    document.title = title;
  }, [title]);
}
